// extracted by mini-css-extract-plugin
export default {"logo":"Navbar_logo__wCsog","navbar":"Navbar_navbar__NBY+5","user":"Navbar_user__wpBbo"};